import { useState } from 'react';
import './TextSummarizer.css';
import { summarizeTextAPI } from '../API/summaryAPI';
import DOMPurify from 'dompurify';

function TextSummarizer() {
  const [text, setText] = useState('');
  const [summary, setSummary] = useState('');
  const [minLength, setMinLength] = useState(30);
  const [maxLength, setMaxLength] = useState(100);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const sanitizedInput = DOMPurify.sanitize(e.target.value);
    setText(sanitizedInput);
  };

  const handleMinLengthChange = (e) => {
    const value = parseInt(e.target.value);
    if (value <= maxLength) {
      setMinLength(value);
      setError('');
    } else {
      setError('Minimum length should be less than or equal to maximum length');
    }
  };

  const handleMaxLengthChange = (e) => {
    const value = parseInt(e.target.value);
    if (value >= minLength) {
      setMaxLength(value);
      setError('');
    } else {
      setError('Maximum length should be greater than or equal to minimum length');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (minLength > maxLength) {
      setError('Minimum length should be less than or equal to maximum length');
      return;
    }
    setLoading(true);
    try {
      const response = await summarizeTextAPI(text, minLength, maxLength);
      if (response) {
        const sanitizedResponse = DOMPurify.sanitize(response);
        setSummary(sanitizedResponse);
      } else {
        setError('Failed to summarize the text.');
      }
    } catch (error) {
      console.error('Error summarizing text:', error);
      setError('An error occurred while summarizing the text. Please try again.');
    }
    setLoading(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(summary).then(() => {
      alert('Summary copied to clipboard!');
    }).catch((err) => {
      console.error('Failed to copy text:', err);
      setError('Failed to copy the summary to the clipboard.');
    });
  };

  return (
    <div className="container">
      <h1>Text Summarizer</h1>
      <div className="interface">
        <div className="inputArea">
          <form onSubmit={handleSubmit}>
            <textarea
              value={text}
              onChange={handleChange}
              rows="10"
              cols="50"
              placeholder="Enter text to summarize..."
            />
            <div className="sliderContainer">
              <label>
                Min Length:
                <input
                  type="range"
                  min="10"
                  max="100"
                  value={minLength}
                  onChange={handleMinLengthChange}
                />
                {minLength}
              </label>
              <label>
                Max Length:
                <input
                  type="range"
                  min="50"
                  max="500"
                  value={maxLength}
                  onChange={handleMaxLengthChange}
                />
                {maxLength}
              </label>
            </div>
            {error && <p className="error">{error}</p>}
            <button type="submit" disabled={loading}>
              {loading ? <div className="spinner"></div> : 'Summarize'}
            </button>
          </form>
        </div>
        <div className="outputArea">
          {summary && (
            <div>
              <h2>Summary:</h2>
              <p>{summary}</p>
              <button onClick={handleCopy} className="copyButton">Copy</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TextSummarizer;
